import { FC } from "react";
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableBody } from "@mui/material";
import { IInvoicePosition } from "../InvoicePage";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#b8a58abe',
        color: theme.palette.common.black,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
    },
}));


const CustomTableCell = styled(StyledTableCell, {
    shouldForwardProp: (prop) => prop !== 'hasBorder'
})<{ hasBorder?: boolean }>(({ hasBorder }) => ({
    borderRight: hasBorder ? "1px solid #E0E0E0" : "none",
    padding: '4px',
    fontSize: '12px',
    border: '1px solid #222',
}));


const StyledTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'hasBorder'
})<{ hasBorder?: boolean }>(({ hasBorder }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#eae5deff',
    },
}));


interface TableProps {
    invoicePositions: IInvoicePosition[];
}

const InvoiceTable: FC<TableProps> = ({
    invoicePositions
}) => {
    let summary = 0;

    return (
        <TableContainer>
            <Table aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <CustomTableCell sx={{ width: '10px', textAlign: 'center' }} hasBorder>LP</CustomTableCell>
                        <CustomTableCell sx={{ width: '250px', textAlign: 'center' }} hasBorder>NAZWA</CustomTableCell>
                        <CustomTableCell sx={{ width: '350px', textAlign: 'center' }} hasBorder>OPIS POZYCJI</CustomTableCell>
                        <CustomTableCell sx={{ textAlign: 'center' }} hasBorder>ILOŚĆ</CustomTableCell>
                        <CustomTableCell sx={{ textAlign: 'center' }} hasBorder>CENA BRUTTO</CustomTableCell>
                        <CustomTableCell sx={{ textAlign: 'center' }} hasBorder>VAT [%]</CustomTableCell>
                        <CustomTableCell sx={{ textAlign: 'center' }} hasBorder>WARTOŚĆ NETTO</CustomTableCell>
                        <CustomTableCell sx={{ textAlign: 'center' }} hasBorder>WARTOŚĆ VAT</CustomTableCell>
                        <CustomTableCell sx={{ textAlign: 'center' }}>WARTOŚĆ BRUTTO</CustomTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invoicePositions.map((row, index) => {
                        const grossValue = row.grossPrice * row.quantity;
                        const netValue = grossValue / (1 + row.vat / 100);
                        const vatValue = grossValue - netValue;
                        summary = summary + grossValue;
                        return (
                            <StyledTableRow key={index}>
                                <CustomTableCell hasBorder sx={{ textAlign: 'center', wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{index + 1}</CustomTableCell>
                                <CustomTableCell hasBorder sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{row.name}</CustomTableCell>
                                <CustomTableCell hasBorder sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{row.description}</CustomTableCell>
                                <CustomTableCell hasBorder sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{row.quantity}</CustomTableCell>
                                <CustomTableCell hasBorder sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{row.grossPrice}</CustomTableCell>
                                <CustomTableCell hasBorder sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{row.vat}</CustomTableCell>
                                <CustomTableCell hasBorder sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{netValue.toFixed(2)}</CustomTableCell>
                                <CustomTableCell hasBorder sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{vatValue.toFixed(2)}</CustomTableCell>
                                <CustomTableCell sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{grossValue.toFixed(2)}</CustomTableCell>
                            </StyledTableRow>
                        )
                    })}
                </TableBody>
            </Table>
            <div
                style={{
                    width: "100%",
                    background: "#b8a58abe",
                    fontWeight: 700,
                    fontSize: 16,
                    letterSpacing: 1,
                    padding: "12px 0px",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 32,
                    marginTop: 16,
                }}
            >
                <span>WARTOŚĆ:</span>
                <span style={{ marginRight: 50 }}>
                    {summary.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")} PLN
                </span>
            </div>
        </TableContainer>
    )
}

export default InvoiceTable;